module.exports = __webpack_public_path__ + "img/icon-white-15.3e06a914.svg";